<div *ngIf="!this.selectedPartitionId && this.selectedPartitionId !== 0"
     style="position: relative; top: 50%; transform: translate(0, -50%); display: flex; flex-direction: column; align-items: center; gap: 10px;">
  <label style="font-size: 24px">{{ 'REGISTRY.DEVICE.TEXT.SELECT_PARTITION' | translate }}</label>
</div>
<dx-data-grid
  (onRowClick)="onGatewayRowClick.emit($event)"
  *ngIf="!!this.selectedPartitionId || this.selectedPartitionId === 0"
  [columnAutoWidth]="true"
  [dataSource]="gateways"
  [paging]="{enabled: false}"
  [selectedRowKeys]="selectedRowGateway"
  [showBorders]="true"
  [showRowLines]="false"
  [wordWrapEnabled]="true"
  height="100%"
  id="gatewayDataGrid"
  #gatewayGrid
  keyExpr="id">

  <dxo-toolbar>
    <dxi-item location="before">
      <p style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.GATEWAYS' | translate }}</p>
    </dxi-item>
    <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
    </dxi-item>
    <dxi-item location="before">
      <div *dxTemplate="let data of 'content'">
        <dx-button (onClick)="getGateways()" icon="refresh" stylingMode="text"
                   text="{{'BUTTONS.REFRESH' | translate}}"></dx-button>
      </div>
    </dxi-item>
    <dxi-item location="before">
      <div *dxTemplate="let data of 'content'">
        <dx-button (onClick)="showNewGatewayForm.emit()" hint="{{'BUTTONS.HINTS.ADD' | translate}}" icon="add"
                   stylingMode="text">
          <i class="vr-ic_fluent_add_24_regular"></i>
        </dx-button>
      </div>
    </dxi-item>
  </dxo-toolbar>

  <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
  </dxo-search-panel>
  <dxo-selection mode="single"></dxo-selection>
  <dxi-column [visible]="isColumnVisible('name')" [minWidth]="120" caption="{{'REGISTRY.GATEWAY.NAME' | translate}}" dataField="name"></dxi-column>
  <dxi-column [visible]="hasUpdatedGateways && isColumnVisible('changeType')" [width]="130" caption="" cellTemplate="changeTypeTemplate" dataField="changeType" type="buttons"></dxi-column>
  <dxi-column [visible]="isColumnVisible('macAddress')" [minWidth]="150" caption="{{'REGISTRY.GATEWAY.MACADDRESS' | translate}}" dataField="macAddress"></dxi-column>
  <dxi-column [visible]="isColumnVisible('status')" [minWidth]="110" [calculateDisplayValue]="parseGatewayStatus" caption="{{'REGISTRY.GATEWAY.STATUS' | translate}}"
              dataField="status"></dxi-column>
  <dxi-column [visible]="isColumnVisible('online')" [width]="75" caption="{{'REGISTRY.GATEWAY.ONLINE' | translate}}" cellTemplate="onlineTemplate"
              dataField="online"></dxi-column>

  <dxi-column [visible]="isColumnVisible('actions')" [minWidth]="100" caption="" cellTemplate="actionsTemplate" type="buttons"></dxi-column>

  <!-- Only UPDATED is rendered: for the gateway itself CREATED just means "no pending
       change on its own fields" (the row always exists), so it is not worth a badge. -->
  <div *dxTemplate="let data of 'changeTypeTemplate'">
    <span *ngIf="data.data.changeType === ChangeTypeEnum.UPDATED" class="changeTypeBadge changeTypeUpdated">
      {{ 'REGISTRY.GATEWAY.TEXT.CHANGE_TYPE_UPDATED' | translate }}
    </span>
  </div>

  <div *dxTemplate="let data of 'onlineTemplate'" style="display: flex; justify-content: center">
    <div *ngIf="!data.data.macAddress" class="no-status"></div>
    <div *ngIf="!!data.data.macAddress && data.data.online" class="online-status"></div>
    <div *ngIf="!!data.data.macAddress && !data.data.online" class="offline-status"></div>
  </div>

  <div *dxTemplate="let data of 'actionsTemplate'" style="display: flex; justify-content: center; gap: 10px">

    <!-- REVERT GATEWAY FIELDS -->

    <i (click)="revertGatewayFieldsPendingConfig($event, data.data);"
       *ngIf="data.data.changeType === ChangeTypeEnum.UPDATED"
       [matTooltip]="'REGISTRY.GATEWAY.TOOLTIP.REVERT_GATEWAY_FIELDS' | translate"
       class="material-symbols-outlined custom-action-icon">undo</i>

    <!-- PROVISION -->

    <!-- REPLACE -->
    <i (click)="startReplaceGateway($event, data.data);"
       *ngIf="data.data.status === GatewayStatusEnum.DEVICES_CONFIGURED && !!data.data.macAddress"
       [matTooltip]="'REGISTRY.GATEWAY.TOOLTIP.REPLACE' | translate"
       class="material-symbols-outlined custom-action-icon">find_replace</i>

    <!-- ASSIGN -->
    <i (click)="startAssignGateway($event, data.data);"
       *ngIf="data.data.status === GatewayStatusEnum.FLASHED && !data.data.macAddress"
       [matTooltip]="'REGISTRY.GATEWAY.TOOLTIP.ASSIGN' | translate"
       class="dx-icon-sorted custom-action-icon"></i>

    <!-- SEND CONFIG -->
    <i (click)="uploadConfig($event, data.data);"
       *ngIf="data.data.status === GatewayStatusEnum.CONFIG_NEEDS_UPDATING"
       [matTooltip]="'REGISTRY.GATEWAY.TOOLTIP.SEND_CONFIG' | translate"
       class="dx-icon-upload custom-action-icon"></i>

    <!-- DISMISS -->
    <i
      (click)="showDismissGatewayForm($event, data.data);"
      *ngIf="data.data.status === GatewayStatusEnum.DEVICES_CONFIGURED || data.data.status === GatewayStatusEnum.DISMISSION_ERROR"
      [matTooltip]="'REGISTRY.GATEWAY.TOOLTIP.DISMISS' | translate"
      class="vr-ic_fluent_power_24_regular custom-action-icon"></i>

    <i (click)="openEditGatewayDrawer.emit(data.data);"
       [matTooltip]="'REGISTRY.GATEWAY.TOOLTIP.EDIT' | translate"
       class="dx-icon-edit custom-action-icon"></i>

  </div>

</dx-data-grid>

<dx-popup
  [(visible)]="dismissGatewayForm"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [height]="200"
  [hideOnOutsideClick]="true"
  [fullScreen]="appService.isSmallScreen()"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.GATEWAY.TEXT.DISMISS_GATEWAY' | translate"
  [width]="660">
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="dismissGateway()" [height]="40" type="danger">
      <i class="vr-ic_fluent_power_24_regular" style="padding-right: 4px;"></i>
      <span class="dx-button-text">{{ 'REGISTRY.GATEWAY.TEXT.DISMISS' | translate }}</span>
    </dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="closeDismissGatewayForm()" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <label [innerHTML]="'REGISTRY.GATEWAY.TEXT.CONFIRM_DISMISS' | translate : {gatewayName: gatewayToDismiss?.name}"
           style="font-size: 18px"></label>
  </div>
</dx-popup>

<dx-popup
  (onHiding)="openReplaceGatewayForm = false"
  *ngIf="openReplaceGatewayForm"
  [dragEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [focusStateEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.GATEWAY.TEXT.REPLACE_GATEWAY' | translate"
  [visible]="true"
  [width]="660">
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="replaceGateway()" [disabled]="!checkIfBothGatewaysReplaced()" [height]="40" icon="refresh"
               text="{{'BUTTONS.REPLACE' | translate}}" type="default"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="closeReplaceGatewayForm()" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div
    style="display: flex; position: absolute; flex-direction: column; top: 50px; bottom: 50px; left: 0; right: 0;gap: 10px;padding: 20px;">
    <div style="overflow: hidden; flex: 0 0 auto">
      <dx-data-grid *ngIf="!!gatewayReplaced"
                    [columnAutoWidth]="true"
                    [dataSource]="[gatewayReplaced]"
                    [paging]="{enabled: false}"
                    [selectedRowKeys]="[gatewayReplaced!.id!]"
                    [showBorders]="true"
                    [showRowLines]="false"
                    [wordWrapEnabled]="true"
                    height="100%"
                    id="gatewayToReplace"
                    keyExpr="id"
      >

        <dxo-selection mode="single"></dxo-selection>
        <dxi-column caption="{{'REGISTRY.GATEWAY.NAME' | translate}}" dataField="name"></dxi-column>
        <dxi-column caption="{{'REGISTRY.GATEWAY.MACADDRESS' | translate}}" dataField="macAddress"></dxi-column>

        <dxi-column [calculateDisplayValue]="parseGatewayStatus" caption="{{'REGISTRY.GATEWAY.STATUS' | translate}}"
                    dataField="status"></dxi-column>
        <dxi-column [width]="100" caption="{{'REGISTRY.GATEWAY.ONLINE' | translate}}" cellTemplate="onlineTemplate"
                    dataField="online"></dxi-column>

        <div *dxTemplate="let data of 'onlineTemplate'" style="display: flex; justify-content: center">
          <div *ngIf="!data.data.macAddress" class="no-status"></div>
          <div *ngIf="!!data.data.macAddress && data.data.online" class="online-status"></div>
          <div *ngIf="!!data.data.macAddress && !data.data.online" class="offline-status"></div>
        </div>

      </dx-data-grid>
    </div>

    <div
      style="overflow:hidden; flex: 1 1 10%; display: flex; flex-direction: column; justify-content: center; align-items: center">
      <i class="vr-ic_fluent_arrow_sort_24_regular" style="font-size: 48px;"></i>
    </div>

    <div style="overflow: hidden; flex: 1 1 60%">
      <dx-data-grid
        (onRowClick)="onGatewayToReplaceRowClick($event)"
        *ngIf="!!this.selectedPartitionId || this.selectedPartitionId === 0"
        [columnAutoWidth]="true"
        [dataSource]="gatewaysFiltered!"
        [paging]="{enabled: false}"
        [showBorders]="true"
        [showRowLines]="false"
        [wordWrapEnabled]="true"
        height="100%"
        id="replaceGatewayDataGrid"
        keyExpr="id">
        <dxo-toolbar>
          <dxi-item location="before">
            <p style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.GATEWAYS' | translate }}</p>
          </dxi-item>
          <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
          </dxi-item>
        </dxo-toolbar>

        <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
        </dxo-search-panel>
        <dxo-selection mode="single"></dxo-selection>
        <dxi-column caption="{{'REGISTRY.GATEWAY.NAME' | translate}}" dataField="name"></dxi-column>
        <dxi-column caption="{{'REGISTRY.GATEWAY.MACADDRESS' | translate}}" dataField="macAddress"></dxi-column>
        <dxi-column [calculateDisplayValue]="parseGatewayStatus" caption="{{'REGISTRY.GATEWAY.STATUS' | translate}}"
                    dataField="status"></dxi-column>
        <dxi-column [width]="100" caption="{{'REGISTRY.GATEWAY.ONLINE' | translate}}" cellTemplate="onlineTemplate"
                    dataField="online"></dxi-column>

        <div *dxTemplate="let data of 'onlineTemplate'" style="display: flex; justify-content: center">
          <div *ngIf="!data.data.macAddress" class="no-status"></div>
          <div *ngIf="data.data.online" class="online-status"></div>
          <div *ngIf="!data.data.online" class="offline-status"></div>
        </div>

      </dx-data-grid>
    </div>
  </div>
</dx-popup>


<dx-popup
  (onHiding)="openAssignGatewayForm = false"
  *ngIf="openAssignGatewayForm"
  [dragEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [focusStateEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.GATEWAY.TEXT.ASSIGN_GATEWAY' | translate"
  [visible]="true"
  [width]="660">
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="assignGateway()" [disabled]="!checkIfBothGatewaysAssigned()" [height]="40" icon="save"
               text="{{'BUTTONS.ASSIGN' | translate}}" type="default"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="closeAssignGatewayForm()" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div
    style="display: flex; position: absolute; flex-direction: column; top: 50px; bottom: 50px; left: 0; right: 0;gap: 10px;padding: 20px;">
    <div style="overflow: hidden; flex: 0 0 auto">
      <dx-data-grid
        *ngIf="!!gatewayToAssign"
        [columnAutoWidth]="true"
        [dataSource]="[gatewayToAssign]"
        [paging]="{enabled: false}"
        [selectedRowKeys]="[gatewayToAssign!.id!]"
        [showBorders]="true"
        [showRowLines]="false"
        [wordWrapEnabled]="true"
        height="100%"
        id="gatewayToAssign"
        keyExpr="id">

        <dxo-selection mode="single"></dxo-selection>
        <dxi-column caption="{{'REGISTRY.GATEWAY.NAME' | translate}}" dataField="name"></dxi-column>
        <dxi-column caption="{{'REGISTRY.GATEWAY.MACADDRESS' | translate}}" dataField="macAddress"></dxi-column>
        <dxi-column [calculateDisplayValue]="parseGatewayStatus" caption="{{'REGISTRY.GATEWAY.STATUS' | translate}}"
                    dataField="status"></dxi-column>
        <dxi-column [width]="100" caption="{{'REGISTRY.GATEWAY.ONLINE' | translate}}" cellTemplate="onlineTemplate"
                    dataField="online"></dxi-column>

        <div *dxTemplate="let data of 'onlineTemplate'" style="display: flex; justify-content: center">
          <div *ngIf="!data.data.macAddress" class="no-status"></div>
          <div *ngIf="!!data.data.macAddress && data.data.online" class="online-status"></div>
          <div *ngIf="!!data.data.macAddress && !data.data.online" class="offline-status"></div>
        </div>

      </dx-data-grid>
    </div>

    <div
      style="overflow:hidden; flex: 1 1 10%; display: flex; flex-direction: column; justify-content: center; align-items: center">
      <i class="vr-ic_fluent_arrow_sort_24_regular" style="font-size: 48px;"></i>
    </div>

    <div style="overflow: hidden; flex: 1 1 60%">
      <dx-data-grid
        (onRowClick)="onGatewayToAssignRowClick($event)"
        *ngIf="!!this.selectedPartitionId || this.selectedPartitionId === 0"
        [columnAutoWidth]="true"
        [dataSource]="gatewaysFiltered!"
        [paging]="{enabled: false}"
        [showBorders]="true"
        [showRowLines]="false"
        [wordWrapEnabled]="true"
        height="100%"
        id="assignGatewayDataGrid"
        keyExpr="id">

        <dxo-toolbar>
          <dxi-item location="before">
            <p style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.GATEWAYS' | translate }}</p>
          </dxi-item>
          <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
          </dxi-item>
        </dxo-toolbar>

        <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
        </dxo-search-panel>
        <dxo-selection mode="single"></dxo-selection>
        <dxi-column caption="{{'REGISTRY.GATEWAY.NAME' | translate}}" dataField="name"></dxi-column>
        <dxi-column caption="{{'REGISTRY.GATEWAY.MACADDRESS' | translate}}" dataField="macAddress"></dxi-column>
        <dxi-column [calculateDisplayValue]="parseGatewayStatus" caption="{{'REGISTRY.GATEWAY.STATUS' | translate}}"
                    dataField="status"></dxi-column>
        <dxi-column [width]="100" caption="{{'REGISTRY.GATEWAY.ONLINE' | translate}}" cellTemplate="onlineTemplate"
                    dataField="online"></dxi-column>

        <div *dxTemplate="let data of 'onlineTemplate'" style="display: flex; justify-content: center">
          <div *ngIf="!data.data.macAddress" class="no-status"></div>
          <div *ngIf="data.data.online" class="online-status"></div>
          <div *ngIf="!data.data.online" class="offline-status"></div>
        </div>

      </dx-data-grid>
    </div>
  </div>
</dx-popup>
